import React, { useState, useEffect } from "react";
import { colors } from "../../../themes/Colors";
import TabButtonFlatButton from "../tab-buttons/TabButtonFlatButton";
import {
  ManageVehicleView,
  PrivateInfoPopCheck,
  VehicleCard,
} from "./components";
import SearchBar from "../search-bar/SearchBar";
import BaseButtons from "../base-buttons/BaseButtons";
import AddVehiclePopUp from "./components/add-vehicle-pop-up/AddVehiclePopUp";
import BaseButtonsIcon from "../base-buttons-icon/BaseButtonsIcon";

const VehicleDisplayCrossModule = ({
  type,
  width,
  setAddVehiclePopUp,
  setVehicleManageView,
  setLoading,
  user,
  refresh,
  setRefresh,
  setMessage,
  setPopUpTitle,
  setToastPop,
  privateInformation,
  auth,
  vehicleManageView,
  height,
  onCloseClick,
}) => {
  const [tableDisplay, setTableDisplay] = useState("vehicles");
  const [viewVehicleData, setViewVehicleData] = useState(null);
  const [addVehicle, setAddVehicle] = useState(false);
  const [manageVehicle, setManageVehicle] = useState(false);

  const [vehicleTableSelectDisplay, setVehicleTableSelectDisplay] =
    useState("driven");

  const [userVehicleList, setUserVehicleList] = useState(null);

  // need to check personal information if it is not added then create pop that notifys users of steps to complete process

  const ColorSwitch = () => {
    if (type === "consumer") {
      return colors.greenLight;
    } else if (type === "org") {
      return colors.primaryOrange;
    } else if (type === "agency") {
      return colors.primaryBlue;
    }
  };

  const getUserVehicleList = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userVehicles/getUserVehicleList",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: user.userId,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setLoading(false);
        setUserVehicleList(respnseData.vehicleList);
        // setToastPop(true);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserVehicleList();
  }, [refresh]);
  return (
    <div
      style={{
        height: width > 899 ? "88%" : type === "consumer" ? "84%" : "55%",
        maxHeight: 900,
        minHeight: width > 899 ? 450 : 300,
        width: "93.5%",
        minWidth: width > 899 ? 500 : width,
        maxWidth: 1500,
        backgroundColor: colors.secondaryGrey,
        marginTop: width > 899 ? 16 : null,
        // borderRadius: 20,
        marginLeft: width > 899 ? 5 : 0,
        WebkitBoxShadow:
          width > 899
            ? "-2px 20px 40px -10px #000000"
            : "0px 0px 0px 0px #000000",
        borderStyle: width > 899 ? "solid" : "none",
        borderWidth: 4,
        borderColor: colors.white,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        overflow: "hidden",
        position: "relative",
        flexDirection: "column",
      }}
    >
      {/* tabs display */}
      {width > 899 ? (
        <div
          style={{
            position: "fixed",
            top: 30,
            display: "flex",
            zIndex: 2,
            left: 245,
          }}
        >
          <div style={{ marginLeft: 14 }}>
            <TabButtonFlatButton
              title={"VEHICLES"}
              backgroundColor={
                tableDisplay === "vehicles" ? ColorSwitch() : colors.white
              }
              textColor={
                tableDisplay === "vehicles"
                  ? colors.white
                  : colors.secondaryDarkBlue
              }
              onClick={() => setTableDisplay("vehicles")}
            />
          </div>
          <div style={{ marginLeft: 5 }}>
            <TabButtonFlatButton
              title={"DRIVERS"}
              backgroundColor={
                tableDisplay === "drivers" ? ColorSwitch() : colors.white
              }
              textColor={
                tableDisplay === "drivers"
                  ? colors.white
                  : colors.secondaryDarkBlue
              }
              onClick={() => setTableDisplay("drivers")}
            />
          </div>
          <div style={{ marginLeft: 5 }}>
            <TabButtonFlatButton
              title={"ENATIS"}
              backgroundColor={
                tableDisplay === "enatis" ? ColorSwitch() : colors.white
              }
              textColor={
                tableDisplay === "enatis"
                  ? colors.white
                  : colors.secondaryDarkBlue
              }
              onClick={() => setTableDisplay("enatis")}
            />
          </div>
        </div>
      ) : null}
      {width < 899 ? (
        <div
          style={{
            width: "100%",

            height: 80,
            position: "absolute",
            top: -20,

            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-evenly",
          }}
        >
          <div
            onClick={() => setVehicleTableSelectDisplay("driven")}
            style={{
              height: "100%",
              flex: 0.3,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              // borderBottomStyle: "solid",
              // borderWidth: buzzDisplay === "today" ? 3 : 0,
              // borderColor: colors.greenLight,
              transition: "all 0.3s",
              WebkitBoxShadow:
                vehicleTableSelectDisplay === "driven"
                  ? "-5px 5px 15px -1px #00000070"
                  : "0px 0px 0px 0px #00000070",
              borderBottomRightRadius:
                vehicleTableSelectDisplay === "driven" ? 8 : 4,
              borderBottomLeftRadius:
                vehicleTableSelectDisplay === "driven" ? 8 : 4,
              backgroundColor:
                vehicleTableSelectDisplay === "driven"
                  ? colors.greenDark
                  : colors.white,
            }}
          >
            <div
              style={{
                marginBottom: vehicleTableSelectDisplay === "driven" ? -10 : 0,
                fontWeight:
                  vehicleTableSelectDisplay === "driven" ? "bold" : "bold",
                color:
                  vehicleTableSelectDisplay === "driven"
                    ? colors.white
                    : "#00000080",
                transition: "all 0.3s",
              }}
            >
              DRIVEN
            </div>
          </div>

          <div
            onClick={() => setVehicleTableSelectDisplay("owned")}
            style={{
              height: "100%",
              flex: 0.3,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              // borderBottomStyle: "solid",
              // borderWidth: buzzDisplay === "forYou" ? 3 : 0,
              // borderColor: colors.greenLight,
              transition: "all 0.3s",
              WebkitBoxShadow:
                vehicleTableSelectDisplay === "owned"
                  ? "-5px 5px 15px -1px #00000070"
                  : "0px 0px 0px 0px #00000070",
              borderBottomRightRadius:
                vehicleTableSelectDisplay === "owned" ? 8 : 4,
              borderBottomLeftRadius:
                vehicleTableSelectDisplay === "owned" ? 8 : 4,
              backgroundColor:
                vehicleTableSelectDisplay === "owned"
                  ? colors.greenDark
                  : colors.white,
            }}
          >
            <div
              style={{
                marginBottom: vehicleTableSelectDisplay === "owned" ? -10 : 0,
                fontWeight:
                  vehicleTableSelectDisplay === "owned" ? "bold" : "bold",
                color:
                  vehicleTableSelectDisplay === "owned"
                    ? colors.white
                    : "#00000080",
                transition: "all 0.3s",
              }}
            >
              OWNED
            </div>
          </div>
          <div
            onClick={() => setVehicleTableSelectDisplay("enatis")}
            style={{
              height: "100%",
              flex: 0.3,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              // borderBottomStyle: "solid",
              // borderWidth: buzzDisplay === "forYou" ? 3 : 0,
              // borderColor: colors.greenLight,
              transition: "all 0.3s",
              WebkitBoxShadow:
                vehicleTableSelectDisplay === "enatis"
                  ? "-5px 5px 15px -1px #00000070"
                  : "0px 0px 0px 0px #00000070",
              borderBottomRightRadius:
                vehicleTableSelectDisplay === "enatis" ? 8 : 4,
              borderBottomLeftRadius:
                vehicleTableSelectDisplay === "enatis" ? 8 : 4,
              backgroundColor:
                vehicleTableSelectDisplay === "enatis"
                  ? colors.greenDark
                  : colors.white,
            }}
          >
            <div
              style={{
                marginBottom: vehicleTableSelectDisplay === "enatis" ? -10 : 0,
                fontWeight:
                  vehicleTableSelectDisplay === "enatis" ? "bold" : "bold",
                color:
                  vehicleTableSelectDisplay === "enatis"
                    ? colors.white
                    : "#00000080",
                transition: "all 0.3s",
              }}
            >
              ENATIS
            </div>
          </div>
        </div>
      ) : null}
      {width < 899 ? <div style={{ minHeight: 60 }} /> : null}
      <div
        style={{
          display: "flex",
          height: 50,
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: 8 }} />
        <SearchBar size={250} />
        <div style={{ minWidth: 10 }} />
        <BaseButtonsIcon
          borderRadius={8}
          height={40}
          width={40}
          icon={require("../../../images/icons/infoDarkBlue.png")}
          iconHeight={30}
          iconWidth={30}
          marginTop={5}
        />
        <div style={{ minWidth: 10 }} />
        <BaseButtonsIcon
          borderRadius={8}
          height={40}
          width={40}
          icon={require("../../../images/icons/infoDarkBlue.png")}
          iconHeight={30}
          iconWidth={30}
          marginTop={5}
        />
      </div>
      <div
        style={{
          flex: 1,
          //   borderStyle: "solid",
          height: "99%",
          borderRadius: 17,
          //   borderColor: ColorSwitch(),
          flexWrap: width > 899 ? "wrap" : "none",
          flexDirection: width > 899 ? null : "column",
          display: "flex",
          justifyContent: width > 899 ? "center" : "flex-start",
          alignItems: "center",
          overflowY: "scroll",
          scrollbarWidth: "none",
          width: "100%",
        }}
      >
        {userVehicleList
          ? userVehicleList.map((vehicle, index) => {
              return (
                <div
                  key={index}
                  style={{
                    minHeight: 120,
                    width: width > 1200 ? 470 : "110%",

                    borderRadius: 10,
                    margin: 10,
                    position: "relative",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    // overflow: "hidden",
                    paddingBottom:
                      index === userVehicleList.length - 1 ? 40 : 0,
                  }}
                >
                  <VehicleCard
                    width={width}
                    onManageClick={
                      width > 899
                        ? () => setManageVehicle(vehicle)
                        : () => setVehicleManageView(vehicle)
                    }
                    type={type}
                    productName={"239764897634jdjjs"}
                    registrationNr={vehicle.registerNumber}
                    vin_nr={vehicle.vinNumber}
                    licenceNr={vehicle.liscenseNumber}
                    engineNr={vehicle.engineNumber}
                    make={vehicle.make}
                    series={vehicle.series}
                    expireDate={"200 days"}
                    index={index + 1}
                  />
                </div>
              );
            })
          : "loading"}
      </div>
      {width > 899 ? (
        <ManageVehicleView
          display={manageVehicle}
          onCloseClick={() => setManageVehicle(null)}
          height={height}
          width={width}
          auth={auth ? auth.customerUserData : null}
          //   onCloseClick={() => setAddVehicle(false)}
        />
      ) : null}
      {width > 899 ? (
        <AddVehiclePopUp
          height={height}
          width={width}
          display={addVehicle}
          onCloseClick={() => setAddVehicle(false)}
          type={"consumer"}
          setLoading={setLoading}
          setMessage={setMessage}
          setPopUpTitle={setPopUpTitle}
          setToastPop={setToastPop}
          setRefresh={setRefresh}
          refresh={refresh}
          auth={auth ? auth.customerUserData : null}
          user={privateInformation ? privateInformation : null}
        />
      ) : null}
      {width < 899 ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            bottom: 70,
            zIndex: 1,
          }}
        >
          <BaseButtons
            label={"ADD VEHICLE"}
            borderRadius={8}
            backgroundColor={colors.orangeDark}
            height={50}
            width={"90%"}
            onClick={() => setAddVehiclePopUp(true)}
            disabled={privateInformation ? false : true}
          />
        </div>
      ) : null}
      <PrivateInfoPopCheck
        display={privateInformation ? false : true}
        onCloseClick={onCloseClick}
      />
    </div>
  );
};

export default VehicleDisplayCrossModule;
